export const extractTitleMessage = (information, title) => {
  return information[title]
    ? information[title]
    : { title, message: `${title}-MESSAGE` };
};
